<template>
  <span class="esra-rating-indicator">
    <ElTooltip
      v-if="isMissingRating"
      :content="$t('APPS.LIST.ESRA_TOOLTIP')"
      placement="top"
    >
      <i class="material-icons esra-rating-indicator__warning">
        error_outline
      </i>
    </ElTooltip>

    <ElTooltip
      v-else-if="app.esraRating"
      :content="$t('APPS.LIST.ESRA_RATING', { age: app.esraRating.age })"
      placement="top"
    >
      <span class="esra-rating-indicator__age" dir="ltr">
        {{ app.esraRating.age }}
      </span>
    </ElTooltip>
  </span>
</template>

<script>
import { needsEsraRating } from './esraRating';

export default {
  name: 'EsraRatingIndicator',

  props: {
    app: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isMissingRating() {
      return needsEsraRating(this.app);
    },
  },
};
</script>

<style lang="scss">
.esra-rating-indicator {
  display: inline-flex;
  align-items: center;
  margin-left: $global-margin / 2;

  @include rtl() {
    margin-right: $global-margin / 2;
    margin-left: 0;
  }

  &__warning {
    color: $lb-color-alert;
    font-size: rem-calc(20);
    vertical-align: middle;
  }

  &__age {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: rem-calc(32);
    height: rem-calc(24);
    padding: 0 $global-padding / 3;
    border: 1px solid $lb-light-gray;
    border-radius: rem-calc(12);
    font-size: $small-font-size;
    font-weight: bold;
  }
}
</style>
